import React from "react";
import { Dimensions, Image, TouchableOpacity, View } from "react-native";
import { ButtonTypeDLS, ButtonWidthTypeToken, ColorTokens, TextAlignTokens, TypographyTypeDLS } from "@voltmoney/schema";
import { SCREEN_SIZE } from '@voltmoney/types';
import { Typography } from "../../typography/Typography";
import BoilerPlate from "../boilerPlate/BoilerPlate";
import { Button } from "../../button/Button";
const ASESDocumentsRejected = ({ height, triggerAction, needHelpAction, retryAction }) => {
    const bottomView = () => {
        return (React.createElement(View, null,
            React.createElement(View, { style: { paddingHorizontal: 16 } },
                React.createElement(Button, { label: "Retry document upload", typeDLS: ButtonTypeDLS.PRIMARY, width: ButtonWidthTypeToken.FULL, onPress: () => {
                        triggerAction({
                            ...retryAction
                        });
                    } }),
                React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'center', marginBottom: 16, marginTop: 24 } },
                    React.createElement(Typography, { label: "Need help? ", typeDLS: TypographyTypeDLS.B0R, color: ColorTokens.Grey_Night }),
                    React.createElement(TouchableOpacity, { onPress: () => {
                            triggerAction({
                                ...needHelpAction
                            });
                        }, activeOpacity: 1 },
                        React.createElement(Typography, { label: "Contact us", typeDLS: TypographyTypeDLS.B0S, color: ColorTokens.Primary_100 }))))));
    };
    const bodyView = () => {
        return (React.createElement(View, { style: {
                paddingHorizontal: 24,
                height: height - 140,
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center'
            } },
            React.createElement(Image, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/document_upload_rejected.png" }, style: { width: 164, height: 164, marginBottom: 16 } }),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: "Retry document upload", color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0R, label: "Documents uploaded by you were rejected. Please upload the documents again to proceed.", color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }))));
    };
    return (React.createElement(View, { style: { marginHorizontal: -16 } },
        React.createElement(BoilerPlate, { height: height - 16, bottomChildren: React.createElement(React.Fragment, null, bottomView()) }, React.createElement(React.Fragment, null, bodyView()))));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
export default (ASESDocumentsRejected);
